import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import {
  Typography,
  Button,
  Alert,
  Breadcrumbs,
  Link,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useQuery } from '@tanstack/react-query';
import { getSupportAuditFeed } from 'apis/supportAPIs';
import { SupportRoleGuard, AuditTable } from './components';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    flexGrow: 1,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
  breadcrumbs: {
    marginBottom: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
}));

const AuditFeed = () => {
  const classes = useStyles();
  const { restaurantId } = useParams();
  const history = useHistory();

  const {
    data: audits,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: ['supportAudit', restaurantId],
    queryFn: () => getSupportAuditFeed({ restaurantId }),
    staleTime: 15000,
  });

  return (
    <SupportRoleGuard>
      <div className={classes.root}>
        <Breadcrumbs className={classes.breadcrumbs} aria-label="Audit breadcrumb">
          <Link
            color="inherit"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              history.push('/support');
            }}
          >
            Support
          </Link>
          <Link
            color="inherit"
            href="#"
            onClick={(e) => {
              e.preventDefault();
              history.push('/support');
            }}
          >
            {restaurantId}
          </Link>
          <Typography color="textPrimary">Audit Log</Typography>
        </Breadcrumbs>

        <div className={classes.header}>
          <Typography variant="h4">Audit Log</Typography>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => history.goBack()}
          >
            Back
          </Button>
        </div>

        {isError && (
          <Alert severity="error">{error?.message || 'Failed to load audit feed'}</Alert>
        )}

        <div className={classes.content}>
          <AuditTable
            audits={Array.isArray(audits) ? audits : audits?.events || []}
            loading={isLoading}
          />
        </div>
      </div>
    </SupportRoleGuard>
  );
};

export default AuditFeed;
